export enum Types {
	CONSULTA_USUARIO_PENDENTE = '@aac/CONSULTA_USUARIO_PENDENTE',
	CONSULTA_USUARIO_PENDENTE_SUCCESS = '@aac/CONSULTA_USUARIO_PENDENTE_SUCCESS',
	CONSULTA_USUARIO_PENDENTE_FAILURE = '@aac/CONSULTA_USUARIO_PENDENTE_FAILURE',
	LIMPA_USUARIO_PENDENTE = '@aac/LIMPA_USUARIO_PENDENTE',
}

export interface UsuarioPendente {
	status: number;
	resultado: ConsultaUsuarioPendente[] | null;
}

export interface ConsultaUsuarioPendente {
	codigoValidacao: string;
	id: string;
	posto: string;
	tipoEncaminhamento: string;
	dataEmissaoAtestado: string;
	usuarioCentral: string;
	tipoLiberacao: string;
	exigenciaProcurado: boolean;
	exigenciaPreso: boolean;
	exigenciaEvadido: boolean;
	exigenciaCopiaApresentado: boolean;
	exigenciaBaixaDesaparecido: boolean;
	exigenciaCertidaoObjeto: boolean;
	exigenciaCertidaoCriminais: boolean;
	exigenciaCertidaoDistribuidor: boolean;
	exigenciaBO: boolean;
	exigenciaBONumero: string;
	exigenciaBODelegacia: string;
	exigenciaObservacao: boolean;
	usuarioPosto: string;
	dataCentralEncerrado: string;
	numeroRg: string;
	nome: string;
	nomePai: string;
	nomeMae: string;
	sexo: string;
	dataNascimentoTs: string;
	dataNascimento: string;
	dataExpedicaoRg: string;
	resultado: string;
	status: string;
	retorno: string;
	usuario: string;
	tipoDocApresentado: string;
	nomeSocial: string;
	cpf: string;
	dcCpf: string;
	exigenciasIP: string[];
	exigenciasDelegacia: string[];
	exigenciasInstauracao: string[];
	exigenciasProcesso: string[];
	exigenciasVara: string[];
	exigenciasCertidaoDistribuidor: string[];
	exigenciasCertidaoCriminais: string[];
	exigenciasObservacao: string[];
	positivaInicio: string;
	positivaTermino: string;
	positivaRegime: string;
	positivaExecucao: string;
	naoPgtoNumeroCertidao: string;
	naoPgtoDataCertidao: string;
	positivasObservacao: string[];
	dc: string;
	tipoDoc: string;
	tipoAA: string;
	encerrado: string;
	nomeProcurador: string;
	docProcurador: string;
}

export interface RequestConsultaUsuarioPendente {
	identifUsuario: string;
	numeroPosto: string;
}
